module.exports = __webpack_public_path__ + "img/404.2d19f675.png";